import { IgenomicsAction } from '../../core/interfaces/genomics-action.interface';
import { cacheActionCreator, cacheSyncActionCreator } from '../../core/utils/store.util';
import { WorkflowConfigModule } from '../workflow-config.module';
import { WorkflowConfigService } from '../services/workflow-config.service';
import { Observable } from 'rxjs/Observable';
import { castToType, CastTypes } from '../../core/utils/type-casting,util';
import {WorkflowDrivenCacheablesEntity} from "@ispm/workflow/entities/workflow-driven-cacheables.entity";
import * as immutable from 'immutable';

export function workflowDrivenCacheActionCreator<T>(type: string): (payload: T) => IgenomicsAction<T> {
  return (payload => cacheActionCreator<T>(type)(payload, <any> WorkflowDrivenCacheablesEntity));
}

export function workflowDrivenCacheSyncActionCreator<T>(type: string): (payload: T) => IgenomicsAction<T> {
  return (payload => cacheSyncActionCreator<T>(type)(payload, <any> WorkflowDrivenCacheablesEntity));
}


export function getActiveRecord<T = any>(state: Object, fallbackValue: any = null, castTo?: CastTypes | null): Observable<T> {
  const workflowConfigService = WorkflowConfigModule.injector.get(WorkflowConfigService) as WorkflowConfigService;
  return workflowConfigService.getCacheKey()
    .map(key => {
      return getRecord(state, key) || fallbackValue;
    })
    .map(activeValue => castTo && activeValue ? castToType(castTo, activeValue) : activeValue);
}

export function getActiveRecordSync<T = any>(state: Object, fallbackValue: any = null, castTo?: CastTypes | null): T {
  const workflowConfigService = WorkflowConfigModule.injector.get(WorkflowConfigService) as WorkflowConfigService;
  const activeValue = getRecord(state, workflowConfigService.cacheKey) || fallbackValue;
  return castTo && activeValue ? castToType(castTo, activeValue) : activeValue;
}

function getRecord(value: immutable.Map<string, any> | object, key: string) {
  if (immutable.Map.isMap(value)) {
    return (<immutable.Map<string, any>> value).get(key);
  }
  else if (value && value.constructor.name.toLowerCase() === 'object') {
    return value[key];
  }
  else {
    return null;
  }
}
